import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import Routes from './Routes';
import './styles/index.css';

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <Routes />
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;